(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('operatingTimeFormat', operatingTimeFormat);

    /** @ngInject */
    function operatingTimeFormat() {
        return function(text) {

          if(!text) return;

          return text.replace(/-/g, ":");
        };
    }

})();
